module.exports = __webpack_public_path__ + "static/img/1.cb2c625.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/shuzihua/1.jpg
// module id = w0OL
// module chunks = 1 2